<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
		<v-card tile>
			<v-toolbar card dark color="primary">
				<v-btn icon dark @click.native="closeDialog()">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items>
				</v-toolbar-items>
			</v-toolbar>
			<v-card-text v-if="dialog">
                <employee-position-description :employee-id="employeeId" :id="id" @onAcknowledged="onAcknowledged" />
			</v-card-text>

			<div style="flex: 1 1 auto;"></div>
		</v-card>
	</v-dialog>
</template>

<script>
	import EmployeePositionDescription from '@/components/employee/EmployeePositionDescription';

	export default {
		components: {
			EmployeePositionDescription
		},
		props: {
			employeeId: {
				required: true
			},
			id: {
				// PD Id
				required: true
			},
            dialog: {
                type: Boolean
            },
            title: {
                type: String,
                required: false
            }
		},
        methods: {
            closeDialog() {
                this.$emit('closeDialog');
            },
            onAcknowledged() {
                this.$emit('onAcknowledged');
            }
        }
	};
</script>

<style></style>
